module.exports = __webpack_public_path__ + "img/taken_billing.be2f3da3.svg";